/* DV-CAMPAIGN-PRESENTATION-V2 block=card-links */
(() => {
  'use strict';
  const SELECTOR = '.dolcevita-discount-badge[data-dv-campaign-variant]';

  function withVariant(href, variantId) {
    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch (_) {
      return href;
    }
  }

  function connectBadge(badge) {
    const variantId = badge.getAttribute('data-dv-campaign-variant');
    if (!variantId || badge.getAttribute('data-dv-link-ready') === variantId) return;
    const card = badge.closest('hdt-card-product, .hdt-card-product');
    if (!card) return;
    card.querySelectorAll('a[data-pr-url][href]').forEach((link) => {
      link.setAttribute('href', withVariant(link.getAttribute('href'), variantId));
    });
    badge.setAttribute('data-dv-link-ready', variantId);
  }

  function connect(root) {
    if (root && root.matches && root.matches(SELECTOR)) connectBadge(root);
    if (root && root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(connectBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => connect(document), { once: true });
  } else {
    connect(document);
  }
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) connect(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
